module.exports = "https://cdn.realtymogul.com/static/media/icon_certificate.4dd8b528.svg";